import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class EnteringExitingWarehouse {
  // 进出仓项目列表
  static getEnteringExitingWarehouseList(options) {
    let url = '/zwy/api/cb/logistics/project/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 开启/关闭进出仓项目
  static postOpenOrColseEnteringExitingWarehouse(id) {
    const url = `/zwy/api/cb/logistics/project/close/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 进出仓项目详情
  static getEnteringExitingWarehouseProjectDetails(id) {
    const url = `/zwy/api/cb/logistics/project/get/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 编辑进出仓项目
  static postModEnteringExitingWarehouseProject(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增进出仓项目
  static postAddEnteringExitingWarehouseProject(data) {
    const url = `/zwy/api/cb/logistics/project/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 进仓操作费枚举
  static getEnteringWarehouseOperate() {
    const url = `/zwy/api/cb/logistics/project/imports/fee/type/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 出仓操作费枚举
  static getExitWarehouseOperate() {
    const url = `/zwy/api/cb/logistics/project/exports/fee/type/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 增值服务枚举
  static getEnterExitWarehouseAddServiceList() {
    const url = `/zwy/api/cb/logistics/project/service/fee/type/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default EnteringExitingWarehouse